import Sidebar from "../Sidebar/Sidebar"; // percorso relativo corretto
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

function PrivateRoute({ children }) {
  const token = localStorage.getItem("authToken");
  const role = useSelector((state) => state.user?.utente?.role);
  // Fallback a localStorage se Redux non ha ancora popolato
  const storedUser = !role ? (() => {
    try {
      return JSON.parse(localStorage.getItem("userData") || "null")?.user;
    } catch {
      return null;
    }
  })() : null;
  const effectiveRole = role || storedUser?.role;

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (effectiveRole !== 'Admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 bg-gray-100 p-6 overflow-auto">{children}</div>
    </div>
  );
}

export default PrivateRoute;
